import { WellStatusTimeScale } from "constants/charts.enums";
import { defaultWellStatusOverTimeRequest } from "entities/charts/eva/requests/wellStatusOverTime";

import { TimeScaleSelector } from "components/charts/toggles/timescale";

/**
 * Time-scale control for the Well Status Over Time chart,
 * mounted on the x-axis where it overlays the "Time" axis title on hover.
 *
 * Five options — Yearly, Monthly, Weekly, Daily and Custom — which deliberately
 * differ from the rig/frac chart's Weekly/Monthly/Quarterly/Custom (product
 * decision superseding the ticket's "same time selector as rigs/frac").
 *
 * Custom behaves exactly as it does on the rig/frac chart: picking it reveals a
 * range picker and changes nothing until Apply commits a valid range. That whole
 * draft-first interaction (and the antd workarounds keeping the calendar open
 * through a pick) lives in the shared TimeScaleSelector rather than being
 * restated here.
 */
const OPTIONS = [
  { value: WellStatusTimeScale.Yearly as string, label: "Yearly" },
  { value: WellStatusTimeScale.Monthly as string, label: "Monthly" },
  { value: WellStatusTimeScale.Weekly as string, label: "Weekly" },
  { value: WellStatusTimeScale.Daily as string, label: "Daily" },
  { value: WellStatusTimeScale.Custom as string, label: "Custom" }
];

function WellStatusTimeScaleSelector() {
  return (
    <TimeScaleSelector
      options={OPTIONS}
      customValue={WellStatusTimeScale.Custom}
      defaultRequest={defaultWellStatusOverTimeRequest()}
      testIdPrefix="well-status"
    />
  );
}

export default WellStatusTimeScaleSelector;
